<div class="sidemenu show" [class.show]="showMenu" (click)="closeMenu()">

  <nav class="">


    <ul>
      <li *ngFor="let item of menuItems[0]" class="menus" [attr.data-test]="item['data-test']">
        <a class="dropdown-item" (click)="gotoAction(item)">
          <span>{{item.name}}</span>
        </a>
      </li>

      <li class="my-3">
        <hr class="dropdown-divider" />
      </li>

      <li *ngFor="let item of menuItems[1]" class="submenus" [attr.data-test]="item['data-test']">
        <a class="dropdown-item" [routerLink]="item.url" (click)="closeMenu()">
          <span>{{item.name}}</span>
        </a>
      </li>
    </ul>
    <div data-test="logout" class="logout my-3">
      <app-button dataTest="add-property-btn" class="dropdown-item " accent block (click)="logout()">Logout
      </app-button>
    </div>
  </nav>
</div>
